<template>

	<div class="mt-4">
		<div class="accordion" id="accordion">

			

			
			<div class="card card-default" v-for="(a, i) in config" :key="i">
				<div class="card-header">
					<h4 class="card-title"> <a class="accordion-toggle" @click="toggle(i)" data-toggle="collapse" data-parent="#accordion" :href="'#collapse' + i">{{a.title}}</a> </h4>
				</div>
				<div :id="'collapse' + i" class="accordion-body collapse">
					<div class="card-body table-responsive-md">
						<accordion :config="a" :user-id="user.userId" :visible="activeNames.indexOf(i) > -1"></accordion>
					</div>
				</div>
			</div>

			



		</div>
	</div>


					

</template>

<script>
	import { rest } from "@/utilities/rest.js";
	import { mapGetters } from "vuex";
	import PackageSummary from "./PackageSummary.vue";
	import AdPurchases from "./AdPurchases.vue";
	import ClassSummary from "./ClassSummary.vue";
	import ClassDetail from "./ClassDetail.vue";
	import PointsSummary from "./PointsSummary.vue";
	import ChallengeSummary from "./ChallengeSummary.vue";
	import ChallengeDetail from "./ChallengeDetail.vue";
	import WebsiteRoles from "./WebsiteRoles.vue";
	import Accordion from "./Accordion.vue";
	export default {
		name: "membership",
		data() {
			return {

				activeNames: [],
				data: {
					
				},

				thinking: {
					save: false,
					visible: false
				}
			}
		},

		components: {
			[PackageSummary.name]: PackageSummary,
			[AdPurchases.name]: AdPurchases,
			[ClassSummary.name]: ClassSummary,
			[ClassDetail.name]: ClassDetail,
			[PointsSummary.name]: PointsSummary,
			[ChallengeSummary.name]: ChallengeSummary,
			[ChallengeDetail.name]: ChallengeDetail,
			[WebsiteRoles.name]: WebsiteRoles,
			[Accordion.name]: Accordion
		},

		created() {
			this.data = JSON.parse(JSON.stringify(this.user));			
		},

		computed: {
			...mapGetters({
				config: "accordionConfig"
			})
		},

		methods: {
			toggle(num) {
				let idx = _.findIndex(this.activeNames, (o => {
					return o === num;
				}));
				
				if (idx > -1) {
					this.activeNames.splice(idx, 1);
				} else {
					this.activeNames.push(num);
				}
				
			}
			
		},

		props: ["user", "isViewingOwnProfile"],

		watch: {
			form(val) {
				if (val) {
					this.data = JSON.parse(JSON.stringify(this.user));
					this.$validator.reset();
				}
			}
		}
	}
</script>

<style>
	/*.el-card.no-pad el-card__body {
		padding: 0;
	}

	.el-card.no-pad .el-collapse-item__header {
		padding-left: 20px;
		padding-right: 20px;
		color: #cc6600;
	}

	.el-card.no-pad .el-collapse-item__wrap {
		padding: 20px;
	}*/
</style>